// extracted by mini-css-extract-plugin
export default {"main":"Glaciers_main__spCRG"};